// extracted by mini-css-extract-plugin
export default {"owner":"AddAdmin_owner__Si-4M","moderator":"AddAdmin_moderator__8sK1A","new":"AddAdmin_new__tAjG4","icons":"AddAdmin_icons__ykz4d"};